module.exports = __webpack_public_path__ + "static/media/54.04f7bc77.png";